export interface MenuItem {
  id: string;
  label: string;
  href?: string;
  icon?: string;
  children?: MenuItem[];
  isSection?: boolean;
  isSeparator?: boolean;
}

export const charityMenuItems: MenuItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    href: '/charity-dashboard',
    icon: 'M8.33348 0.404808C9.01958 -0.134937 9.98032 -0.134935 10.6664 0.404808L18.6309 6.67032C19.3464 7.23318 18.9515 8.39136 18.0471 8.39136H17.0999V16.0783C17.0999 17.1396 16.2492 18 15.1999 18H3.80001C2.75068 18 1.90003 17.1396 1.90003 16.0783V8.39136H0.952808C0.0473931 8.39136 -0.345747 7.23258 0.368988 6.67032L8.33348 0.404808Z'
  },
  {
    id: 'pending-confirmation',
    label: 'Pending Confirmation',
    href: '/pending-confirmation',
    icon: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z'
  },
  {
    id: 'donation-requests',
    label: 'Incoming Donations',
    href: '/donation-requests',
    icon: 'M0.391357 9.43491C-0.738297 5.88202 0.582966 1.46479 4.28566 0.264231C6.23334 -0.368924 8.63688 0.159235 10.0024 2.05658C11.2899 0.0892382 13.763 -0.364682 15.7085 0.264231C19.4102 1.46479 20.7388 5.88202 19.6102 9.43491C17.852 15.0665 11.7174 18 10.0024 18C8.2884 18 2.20849 15.1322 0.391357 9.43491Z'
  },
  {
    id: 'donations-received',
    label: 'Donations Received',
    href: '/payouts',
    icon: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'
  },
  {
    id: 'donors',
    label: 'Donors',
    href: '/donors',
    icon: 'M10.9491 12.54C14.3802 12.5401 17.3094 13.084 17.3094 15.2607C17.3091 17.4362 14.3988 18 10.9491 18C7.51793 18 4.58782 17.4561 4.58773 15.2803C4.58773 13.1035 7.49907 12.54 10.9491 12.54ZM5.56527 11.2295C5.58496 11.2322 5.59473 11.2468 5.59652 11.2549C5.59902 11.2683 5.59376 11.2875 5.56917 11.3018C4.9621 11.6035 2.61844 12.9161 2.91292 15.6826C2.92546 15.8033 2.83084 15.9058 2.71175 15.8887C2.13505 15.8058 0.651458 15.4851 0.191242 14.4863C-0.0637435 13.9578 -0.0637514 13.3459 0.191242 12.8174C0.49208 12.1735 1.2172 11.7297 2.32113 11.5117C2.84312 11.3847 4.25265 11.2052 5.56527 11.2295ZM16.4354 11.2285C17.7467 11.2043 19.1562 11.3848 19.6776 11.5127C20.7816 11.7297 21.5085 12.1725 21.8094 12.8164C22.0637 13.345 22.0636 13.9586 21.8094 14.4863C21.3493 15.4849 19.8658 15.8057 19.2889 15.8887C19.1699 15.9067 19.0735 15.8032 19.0858 15.6836C19.3803 12.9162 17.0378 11.6035 16.4315 11.3018C16.4055 11.2882 16.4005 11.2675 16.4032 11.2549C16.4051 11.2459 16.4158 11.2312 16.4354 11.2285ZM10.9491 2C13.2849 2.0001 15.1578 3.8821 15.158 6.23242C15.158 8.58204 13.2851 10.4667 10.9491 10.4668C8.61295 10.4668 6.73909 8.5821 6.73909 6.23242C6.73932 3.88204 8.61309 2 10.9491 2ZM5.33577 2.70605C5.58102 2.70606 5.81562 2.73152 6.04476 2.77832C6.0752 2.78553 6.10986 2.80111 6.12777 2.82812C6.14828 2.86234 6.13264 2.90878 6.11116 2.93848C5.43344 3.89398 5.0428 5.05962 5.6028 6.30957C5.04289 7.50721 5.40047 8.62327 6.02718 9.55078C6.09126 9.64616 6.0342 9.77502 5.92073 9.79492C5.76326 9.82282 5.60196 9.83728 5.43734 9.8418C3.79431 9.88503 2.3194 8.82094 1.91195 7.21973C1.30755 4.84122 3.07936 2.70605 5.33577 2.70605ZM16.6629 2.70605C18.9193 2.70605 20.6912 4.84122 20.0877 7.21973C19.6803 8.82083 18.2062 9.88486 16.5633 9.8418C16.3987 9.8373 16.2364 9.82188 16.0799 9.79492C15.9663 9.77513 15.9084 9.64621 15.9725 9.55078C16.5992 8.62325 16.9568 7.50725 16.9569 6.30957C16.9569 5.05955 16.5663 3.89401 15.8885 2.93848C15.867 2.90876 15.8514 2.86235 15.8729 2.82812C15.8908 2.80046 15.9237 2.78649 15.9549 2.7793C16.1831 2.73249 16.4177 2.70608 16.6629 2.70605Z'
  },
  {
    id: 'charity-profile',
    label: 'Charity Profile',
    href: '/charity-profile',
    icon: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'
  },
  {
    id: 'charity-bank-account',
    label: 'Bank Account',
    href: '/charity-bank-account',
    icon: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z'
  }
];
